<template>
  <ExamResult :path="'/byl'"></ExamResult>
</template>

<script>
  import ExamResult from '@/page/modules/exam/result'
  export default {
    components: { ExamResult },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/exam/result.vue